
import { defineComponent, provide, markRaw } from "vue";
import {
  CachedMonthsFromAmplitude,
  MonthsFromAmplitude,
} from "./components/entity/submission/settings/months-from-frequency";

export default defineComponent({
  setup() {
    const monthsFromAmplitude: MonthsFromAmplitude = markRaw(
      new CachedMonthsFromAmplitude()
    );
    provide<MonthsFromAmplitude>("monthsFromAmplitude", monthsFromAmplitude);
    return {
      monthsFromAmplitude,
    };
  },
});
